// Shared codes and identity keys for the OM Query Orders By Customer report
// (legacy OMD0010).

// One consistent display name across the sidebar/menu, the listing header and the
// detail header (CLAUDE.md rule 13).
export const SCREEN_NAME = 'Query Orders By Customer';

// OMTRANSACTIONHEADER.RECORDTYPE - the desktop screen switches the Orders grid
// between these two values for its "Orders Open" / "Orders History" tabs.
export const OM_RECORD_TYPE_OPEN = 'R';
export const OM_RECORD_TYPE_HISTORY = 'Z';

// IDCODES code type for the customer Billing Cycle list.
export const ID_CODE_TYPE_BILLING_CYCLE = '01';

// Coded-field option lists for the Additional tab. Kept here rather than inline
// so the values are not magic literals (Architecture.md R2). The customer
// Active/Inactive list and the price-level list are shared app-wide - import
// CUSTOMER_STATUS_OPTIONS / PRICE_LEVEL_OPTIONS from `const/constants` instead
// of redefining them here.
export const PARTIAL_SHIPMENT_OPTIONS = [
    { id: 'Y', name: 'Yes, Partial Shipment' },
    { id: 'N', name: 'No, Partial Shipment' },
];

// Page-size choices shared by every grid on this screen.
export const GRID_PAGE_SIZES = [10, 20, 100, 500, "all"];

// DevExtreme numeric format for every money column across this screen's grids.
export const CURRENCY_FORMAT = "$ #,##0.00";

// GridLayoutManager's built-in layout name, used as the initial currentLayout
// state before the user picks a saved layout.
export const DEFAULT_LAYOUT_NAME = "Default";

// Grid-layout storage keys. Collected here so they stay unique and auditable
// instead of being scattered GUID literals across the tab files.
export const GRID_KEYS = {
    CustomerList: '2F6B9D41-8C05-4E73-A19F-7D3E50B62C84',
    OrdersOpen: '4C81E7A2-3D96-4F50-8B17-2E6A9D045C31',
    OrdersHistory: '5D92F8B3-4EA7-4061-9C28-3F70AE156D42',
    CreditHistory: '6EA309C4-5FB8-4172-AD39-4081BF267E53',
    CashReceipts: '7FB410D5-60C9-4283-BE4A-5192C0378F64',
    AROpenItems: '80C521E6-71DA-4394-CF5B-62A3D1489075',
};

// Dynamic-form layout identities (id + name pairs used by FormField).
export const FORM_LAYOUTS = {
    Search: { id: '3A7C0E52-9D16-4F84-B20A-8E4F61C73D95', name: 'QueryOrdersByCustomerSearchForm' },
    Primary: { id: 'A16D4F82-93C5-4B7E-8D02-6F1A5C39E7B4', name: 'QueryOrdersByCustomerPrimaryForm' },
    Additional: { id: '5E7C2B94-16D8-4A03-BF25-8C41D9E6073B', name: 'QueryOrdersByCustomerAdditionalForm' },
};
